import React, { useEffect, useMemo, useState } from "react";
import { Form, Row, Col, Select, Button, Input } from "antd";
import config from '../../config/form.json'
import SectionHeading from "./section-headings";
import SectionInfo from "./section-info";
import FileUploadCustom from "../onboarding/fileUploadCustom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { editactive, inwardPartner, orgaDetails, productSelection, sayUploadAllDocs , newPartnerList } from "../../store/gloabalState"
import useNotify from "../../utils/useNotify"
import { showDocsAlreadyUploaded } from "../../utils/onboarding/cdocs/show-docs-already-uploaded";
import { updateOrg } from "../../services/httpCalls"
import Cookies from "js-cookie"
import { showField, NEW_REFACTOR} from "../../utils/onboarding/onboardingUtils";

const addressProofOptions = ["UTILITY_BILL", "IEC", "ITR", "SHOP_ESTABLISHMENT"]

const CdocsNew = ({ handleChange }) => {

    // initializing form
    const [form] = Form.useForm();

    // getting cdocs config
    const configData = config.cdocs[0];

    // local states
    const [selectedAddressProof, setSelectedAddressProof] = useState("")
    const [showLoader, setShowLoader] = useState(false)
    const [docsuploadedtrue, setUploadedTrue] = useState(false)
    const [refreshDocs, setRefreshDocs] = useState(false)
    const [companyType, setCompanyType] = useState("")
    const [alreadyuploaded, setAlreadyuploaded] = useState({
        COMPANY_PAN_CARD: false,
        CERTIFICATE_OF_INCORPORATION: false,
        GST_CERTIFICATE: false,
        MOA: false,
        AOA: false,
        BOARD_RESOLUTION: false,
        ANNUAL_DECLARATION: false
    })
    const [uploadedFileList, setUploadedFileList] = useState({
        COMPANY_PAN_CARD: "",
        GST_CERTIFICATE: "",
        CERTIFICATE_OF_INCORPORATION: "",
        MOA: "",
        AOA: "",
        BOARD_RESOLUTION: "",
        ANNUAL_DECLARATION: ""
    })
    const [uploadedFileLinks, setUploadedFileLinks] = useState({
        COMPANY_PAN_CARD: "",
        GST_CERTIFICATE: "",
        CERTIFICATE_OF_INCORPORATION: "",
        MOA: "",
        AOA: "",
        BOARD_RESOLUTION: "",
        ANNUAL_DECLARATION: ""
    })
    const orgDetails_ = useRecoilValue(orgaDetails)

    let renderedFiles = useMemo(() => {
        return []
    },[orgDetails_]);
    // const [renderedFiles, setRenderedFiles] = useState([]);

    // same address
    const [sameAddress, setSameAddress] = useState(false)

    // global states

    // values
    const isEditActive = useRecoilValue(editactive)
    const partnerState = useRecoilValue(inwardPartner);
    const partnerListState = useRecoilValue(newPartnerList);

    // updater/setter
    const setDocsUploadTrue = useSetRecoilState(sayUploadAllDocs)
    const [showNextMove, setShowNextMove] = useRecoilState(sayUploadAllDocs);

    // states
    let [selectionValue, setSelectionValue] = useRecoilState(productSelection)


    // constants/binders
    const notify = useNotify()

    const showDocsAlreadyUploadedCall = async () => {
        await showDocsAlreadyUploaded({
            setShowLoader,
            setSelectionValue,
            setCompanyType,
            selectionValue,
            setUploadedFileList,
            setAlreadyuploaded,
            setUploadedFileLinks,
            companyType
        })
    }

    const checkFileValidation = () => {
        let isFileThere = true;
        renderedFiles.map((item) => {
            if(!alreadyuploaded[item] && isFileThere){
                isFileThere = false;
            }
        })

        return isFileThere;
    }

    // Function to find the first address proof with a true value
    function findFirstTrueEnum(enumsArray, obj) {
    for (let enumKey of enumsArray) {
      if (obj[enumKey] === true) {
        return enumKey;  // Return the first address proof key where the value is true
      }
    }
        return null;  // Return null if no match is found
    }

    useEffect(() => {
        let uploadedAddressProof = findFirstTrueEnum(addressProofOptions, alreadyuploaded);
        if(!selectedAddressProof) setSelectedAddressProof(uploadedAddressProof);
    },[alreadyuploaded])


    useEffect(() => {
        if (selectionValue !== "inward") {
            if (selectionValue === "outward" || selectionValue === "both") {
                if (companyType === "LLP" && selectionValue === "outward") {
                    if (
                        alreadyuploaded.CERTIFICATE_OF_INCORPORATION &&
                        alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE
                    ) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                } else if (companyType === "LLP" && selectionValue === "both") {
                    if (
                        alreadyuploaded.CERTIFICATE_OF_INCORPORATION &&
                        alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE &&
                        alreadyuploaded.LLP_DEED
                    ) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                } else if (companyType === "PARTNERSHIP_FIRM" && selectionValue === "outward") {
                    if (
                        alreadyuploaded.CERTIFICATE_OF_INCORPORATION &&
                        alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE &&
                        alreadyuploaded.AOA &&
                        alreadyuploaded.MOA
                    ) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                } else if (companyType === "PARTNERSHIP_FIRM" && selectionValue === "both") {
                    if (
                        alreadyuploaded.CERTIFICATE_OF_INCORPORATION &&
                        alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE &&
                        alreadyuploaded.AOA &&
                        alreadyuploaded.MOA &&
                        alreadyuploaded.PARTNERSHIP_DEED
                    ) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                } else if(companyType === "SOLE_PRORIETOR"){
                    if(alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE &&
                        alreadyuploaded.SOLE_PROPRIETER_AADHAR_CARD){
                            setDocsUploadTrue(true)
                        } else {
                            setDocsUploadTrue(false)
                        }
                       
                } else {
                    if (
                        alreadyuploaded.CERTIFICATE_OF_INCORPORATION &&
                        alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE &&
                        alreadyuploaded.AOA &&
                        alreadyuploaded.MOA
                    ) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                }
            } else {
                if (companyType === "LLP") {
                    if (
                        alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE &&
                        alreadyuploaded.LLP_DEED
                    ) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                } else if (companyType === "PARTNERSHIP_FIRM") {
                    if (
                        alreadyuploaded.COMPANY_PAN_CARD &&
                        alreadyuploaded.GST_CERTIFICATE &&
                        alreadyuploaded.PARTNERSHIP_DEED
                    ) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                } else {
                    if (alreadyuploaded.GST_CERTIFICATE && alreadyuploaded.COMPANY_PAN_CARD) {
                        setDocsUploadTrue(true)
                    } else {
                        setDocsUploadTrue(false)
                    }
                }

            }
        }
        if(Boolean(partnerState.length) && partnerState.includes("payglocal")){
            if((!["LLP", "FREELANCER"].includes(companyType)) && !selectedAddressProof){
                setDocsUploadTrue(false)
            } else {
                if(checkFileValidation()){
                    setDocsUploadTrue(true)
                } else {
                    setDocsUploadTrue(false)
                }
            }
        }

    }, [alreadyuploaded, refreshDocs, selectedAddressProof])

    useEffect(() => {
        showDocsAlreadyUploadedCall()
    }, [docsuploadedtrue, refreshDocs])

    const next = () => {
        setShowLoader(true)
        if (showNextMove) {
            let data = {
                status: "DRAFT_AUTH_SIGNATORY"
            }
            if (!isEditActive) {
                let orgId = localStorage.getItem("orgId")
                setShowLoader(true)
                updateOrg(data, orgId)
                    .then((res) => {
                        Cookies.set("currentStage", "4")
                        handleChange(4)
                        notify.success("Successfully submitted company documents!")
                    })
                    .finally(() => {
                        setShowLoader(false)
                    })
            } else {
                Cookies.set("currentStage", "4")
                handleChange(4)
            }

        } else {
            notify.error("Please do upload all the documents!")
            setShowLoader(false)
        }
    }

    useEffect(() => {
        if (selectionValue === "inward" && !partnerState.includes('payglocal')) setShowNextMove(true);
    }, [setShowNextMove, selectionValue])

    const isUploaded = (arg) => {
        if(arg === 'custom_address_proof'){
            if(alreadyuploaded?.[selectedAddressProof]){
                return true
            } else {
                return false
            }
        } else {
            return alreadyuploaded?.[arg]
            ? alreadyuploaded?.[arg]
            : false
        }
    }

    const getName = (arg) => {
        if(arg === 'custom_address_proof' && selectedAddressProof){
            return selectedAddressProof
        } else {
            return arg
        }
    }

    const renderField = (field, index) => {
        
        const { type, label, name, props, style, tooltip } = field;

        // formatting rules
        field?.rules?.forEach(item => {
            if (item?.pattern) {
                item.pattern = eval(item?.pattern);
            }
            if (item?.required) {
                item.required = eval(item?.required)
            }
            if (item?.validator) {
                item.validator = eval(item?.validator)
            }
        });
        

        switch (type) {
            case 'FileUploadCustom':
                return (
                    <FileUploadCustom
                        name={getName(name)}
                        type={field?.sub_type}
                        uploadedFileList={eval(props?.uploadedFileList)}
                        uploadedFileLinks={eval(props?.uploadedFileLinks)}
                        isUploaded={eval(props?.isUploaded)}
                        setRefreshDocs={eval(props?.setRefreshDocs)}
                        refresh={eval(props?.refresh)}
                        selectBox={field?.selectBox}
                        selectedAddressProof={selectedAddressProof}
                        setSelectedAddressProof={setSelectedAddressProof}
                    />
                );
            case 'SectionHeading':
                return (
                    <SectionHeading
                        style={field?.style}
                        level={field?.level}
                        heading={field?.heading}
                        Col={field?.Col}
                    />
                );
            case 'SectionInfo':
                return (
                    <SectionInfo />
                )
            default:
                return null;
        }
    }

    useEffect(() => {
        if(orgDetails_ !== null || orgDetails_ !== undefined) {
            
            if (Object.keys(orgDetails_).length > 0 && orgDetails_) {
                const keysToIgnore = ['type', 'id'];
    
                // Create copies of the objects without the ignored keys
                const filteredObj1 = orgDetails_?.addresses[1] ? Object.fromEntries(
                    Object.entries(orgDetails_?.addresses[0]).filter(([key]) => !keysToIgnore.includes(key))
                ): {}
                
                const filteredObj2 = orgDetails_?.addresses[1] ? Object.fromEntries(
                    Object.entries(orgDetails_?.addresses[1]).filter(([key]) => !keysToIgnore.includes(key))
                ) : {}
    
                setSameAddress(JSON.stringify(filteredObj1) === JSON.stringify(filteredObj2))
                setCompanyType(orgDetails_?.companyType)
            }
        }
        
    }, [orgDetails_])

    const replaceAddressProof = (arr, currentElement) => {
        if(arr.length && arr.some(ele => addressProofOptions.includes(ele))){
            arr.forEach((item,index) => {
                if(addressProofOptions.includes(item)){
                    arr[index] = currentElement
                }
             })
        } else {
            arr.push(currentElement)
        }
        return arr;
      }

    return (
        <Form
            {...configData.formConfig}
        >
            <Row gutter={[16, 16]}>
                {configData.fields.map((field, index) => {

                    const isCompanyTypePresent = field?.companyType?.includes(companyType)
                    // conditional render

                    const isVisible = field?.isHeading || (showField(field.productList , partnerListState)  && (field?.companyType?.includes("ALL") || isCompanyTypePresent));

                   
                    const isRefactorRender = isVisible;

                    // MOA and AOA is required for Private and Public company types only (PG)
                    if(orgDetails_?.inwardPayglocal){
                        if (field.name === "MOA" || field.name === "AOA") {
                            if (orgDetails_?.companyType !== "PRIVATE_LIMITED_COMPANY" && orgDetails_?.companyType !== "PUBLIC_LIMITED_COMPANY" && orgDetails_?.companyType !== "OPC") {
                                return false
                            }
                        }
                    }
                    if(orgDetails_?.inwardPayglocal && orgDetails_?.gstNumber && field.name === "ANNUAL_DECLARATION"){
                        return false
                    }
                    if(orgDetails_?.inwardPayglocal && !orgDetails_?.gstNumber && field.name === "GST_CERTIFICATE"){
                        return false
                    }
                    if(isRefactorRender && field?.type === "FileUploadCustom"){
                        if(field?.name === "custom_address_proof"){
                            if((getName(field?.name) !== "custom_address_proof") && !renderedFiles?.includes(getName(field?.name))){
                                renderedFiles = replaceAddressProof(renderedFiles, getName(field?.name))
                            }
                        } else {
                            !renderedFiles?.includes(field?.name) && renderedFiles.push(field?.name)
                        }
                    }
                    return isRefactorRender && (
                        <Col key={index} span={field?.Col ? field.Col : 12}>
                            {renderField(field, index)}
                        </Col>
                    )
                })}
            </Row>
            <div style={{color:"red", padding:'1rem 0 2rem', fontSize:'.8rem'}}>
                <b>Note:</b><i> If GST Certificate is not available please upload the "Format for declaration" </i>
            </div>
            <div className='fixed_btn_wrap'>
                <Button onClick={() => handleChange(2)}>Previous</Button>
                <Button type="primary" style={{ marginLeft: ".5rem" }} onClick={next}>Next</Button>
            </div>
        </Form>
    )

}

export default CdocsNew;